import { getNextStaticProps } from '@faustjs/next';
import { client, PageIdType } from 'client';
import { GetStaticPropsContext } from 'next';
import { useMenu, useGeneralOptionsSettings } from 'hooks';
import Layout from 'layouts/main';
import {
  CEOLink,
  ContactInfo,
  ContactForm,
  BrandColorsDivider,
  GenericDivider,
} from 'components';

export default function Page() {
  const { usePage } = client;
  const headerLinks = useMenu('PRIMARY');
  const footerLinks = useMenu('FOOTER');
  const page = usePage({
    id: `/contact`,
    idType: PageIdType.URI,
  });
  const options = useGeneralOptionsSettings();
  const ceoLink = options?.generalSettings?.ceoLink;
  return (
    <Layout page={page} headerLinks={headerLinks} footerLinks={footerLinks}>
      <section className="section-container w-full flex flex-col justify-start items-center mx-auto mt-20">
        <div className="content-container w-full px-6 md:px-16 lg:px-20 xl:px-0">
          <div className="flex flex-col justify-center items-between sm:items-center sm:flex-row gap-12 xl:gap-48">
            <ContactInfo />
            <GenericDivider className="sm:hidden" />
            <ContactForm />
          </div>
        </div>
        <BrandColorsDivider className="mt-36" />
      </section>
      <CEOLink
        className="h-[70px] w-[271px] fixed bottom-5 right-5 z-50"
        link={ceoLink}
      />
    </Layout>
  );
}

export async function getStaticProps(context: GetStaticPropsContext) {
  return getNextStaticProps(context, {
    Page,
    client,
  });
}
